module.exports = __webpack_public_path__ + "img/sina-video1.26f951ba.jpg";